'use client';
import React, { useState } from 'react';
import { HiXMark } from 'react-icons/hi2';
import { CartState, useCartStore } from '../useCartStore';
import { Cart, CartItem } from '../../../lib/ecwid/ecwidTypes';

const DeleteItemButton = ({
    index,
    translation,
}: {
    index: number;
    item: CartItem;
    translation: Record<string, string>;
}) => {
    const [pending, setPending] = useState(false);
    const [message, setMessage] = useState<string | null>(null);
    const { setCart } = useCartStore((state: CartState) => ({
        setCart: state.setCart,
    }));

    const handleSubmit = async () => {
        setMessage(null);

        try {
            if (typeof window !== 'undefined' && window.Ecwid?.Cart) {
                window.Ecwid.Cart.get(() => {
                    window.Ecwid.Cart.removeProduct(index, function (success) {
                        if (success) {
                            setMessage(
                                translation.itemRemoved ||
                                    'Item removed from cart successfully.',
                            );

                            window.Ecwid.Cart.get((updatedCart: Cart) => {
                                setCart(updatedCart);
                            });
                        } else {
                            setMessage(
                                translation.removeFromCartError ||
                                    'Failed to remove item from cart.',
                            );
                        }
                    });
                });
            } else {
                setMessage(
                    translation.removeFromCartError ||
                        'Ecwid API is not available.',
                );
            }
            setPending(false);
            return null;
        } catch {
            setMessage('Failed to remove item');
        } finally {
            setPending(false);
        }
    };
    return (
        <div>
            {!pending && (
                <button
                    aria-label="Remove cart item"
                    className="ease flex h-[17px] w-[17px] items-center justify-center rounded-full bg-neutral-500 transition-all duration-200"
                    onClick={handleSubmit}
                    style={{ pointerEvents: 'auto' }}
                    type="button"
                >
                    <HiXMark className="hover:text-accent-3 mx-[1px] h-4 w-4 text-white dark:text-black" />
                </button>
            )}
            {message && (
                <p aria-live="polite" className="sr-only" role="status">
                    {message}
                </p>
            )}
        </div>
    );
};
export default DeleteItemButton;
